import { render, staticRenderFns } from "./pri.vue?vue&type=template&id=0068df70"
import script from "./pri.vue?vue&type=script&lang=js"
export * from "./pri.vue?vue&type=script&lang=js"
import style0 from "./pri.vue?vue&type=style&index=0&id=0068df70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports